import { eventQBus } from "../types/EventQBus";
import { findMatch } from "../utils/Dom";
import { event } from "@otto-ec/global-resources/event";
import tracking from "../tracking/Tracking";

let parentContainer: HTMLElement | null;

const SEARCH_RESULT = "reptile-search-result";

export function resolveLinkType(event: MouseEvent) {
  const target = event.target as HTMLElement;
  if (!target) {
    return "";
  }

  const linkTypes = [
    { class: ".reptile_tile__rating", type: "rating" },
    { class: ".find_tile__productLink", type: "text" },
    { class: ".find_tile__productImageLink", type: "image" },
  ] as const;

  for (const linkType of linkTypes) {
    if (target.closest(linkType.class)) {
      return linkType.type;
    }
  }

  return "";
}

function track(productContainer: HTMLElement, linkType: string) {
  const trackingString = productContainer.getAttribute("data-producttile-tracking");
  if (trackingString != null) {
    const decodedString = decodeToUTF8(trackingString).replace("#linkType#", linkType);
    tracking.trackOnNextPageImpression(JSON.parse(decodedString));
  }
}

function decodeToUTF8(base64String: string) {
  const binaryString = atob(base64String);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return new TextDecoder("utf-8").decode(bytes);
}

function handleClick(this: Element, ev: MouseEvent) {
  /*                            */
  let linkType;
  const productContainer = findMatch(
    this as HTMLElement,
    function (element) {
      return element.classList.contains("product");
    },
    parentContainer,
  );

  if (productContainer) {
    linkType = resolveLinkType(ev);
    if (linkType !== "" && !ev.ctrlKey) {
      track(productContainer as HTMLElement, linkType);
    }
  }
}

function onTileListLoaded(selector: string) {
  parentContainer = document.getElementById(selector);
  if (parentContainer == null) {
    parentContainer = document.querySelectorAll<HTMLElement>(".reptile_qr-page")[0];
  }
  if (parentContainer) {
    event.delegate(parentContainer, "click", ".product a", handleClick);
  }
}

export function registerProductTileClickHandling() {
  eventQBus.on("ftfind.tilelist.loaded", () => onTileListLoaded(SEARCH_RESULT));
  onTileListLoaded(SEARCH_RESULT);
}
